import React from "react";
import { Box, Container, Grid, Skeleton, styled } from "@mui/material";

const SkeletonCard = styled(Box)(({ theme }) => ({
  height: "100%",
  display: "flex",
  flexDirection: "column",
  backgroundColor: theme.palette.background.paper,
  borderRadius: theme.spacing(1),
  overflow: "hidden",
  boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
}));

const BookListSkeleton = () => {
  return (
    <Grid container spacing={2}>
      {[1, 2, 3, 4, 5, 6].map((item) => (
        <Grid item xs={12} sm={6} lg={4} key={item}>
          <SkeletonCard>
            <Skeleton variant="rectangular" width="100%" height={300} />
            <Box sx={{ p: 2 }}>
              <Skeleton variant="text" width="80%" height={24} sx={{ mb: 1 }} />
              <Skeleton variant="text" width="60%" height={20} sx={{ mb: 1 }} />
              <Box
                sx={{ display: "flex", justifyContent: "space-between", mt: 2 }}
              >
                <Skeleton variant="rectangular" width={80} height={32} />
                <Skeleton variant="rectangular" width={100} height={32} />
              </Box>
            </Box>
          </SkeletonCard>
        </Grid>
      ))}
    </Grid>
  );
};

export default BookListSkeleton;
